import styled from 'styled-components';
import { AppCard, AppRemixIcon } from '@/layout/AppComponents';

export default function InecoRiskManagerRiskKpiCard({ kpi, onShowKpiModal }) {
  return (
    <AppCard
      header={
        <>
          <span>KPI</span>
          <span
            className="pointer float-right"
            title="Editar"
            onClick={onShowKpiModal}
          >
            <AppRemixIcon icon="edit-box" />
          </span>
        </>
      }
      headerClassName="text-white bg-primary"
    >
      <div>
        <div className="mb-2">
          <span className="font-weight-bold mr-2">Key Results:</span>
          <span>{kpi?.keyResults}</span>
        </div>
        <div className="mb-2">
          <span className="font-weight-bold mr-2">KPI:</span>
          <span>{kpi?.description}</span>
        </div>
        <div className="mb-2">
          <span className="font-weight-bold mr-2">Resultado KPI:</span>
          <span>{kpi?.result}</span>
        </div>
      </div>
    </AppCard>
  );
}
